var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ek-table',{attrs:{"items":_vm.AccountsList,"columns":_vm.cols,"deleteBtn":""},on:{"delete-selected":_vm.deleteAccounts,"details":_vm.goToDetails},scopedSlots:_vm._u([{key:"items.dateCreated",fn:function(ref){
var value = ref.value;
return [_vm._v(" "+_vm._s(value ? new Date(value).toLocaleDateString() : '')+" ")]}},{key:"items.isBlocked",fn:function(ref){
var value = ref.value;
return [_c('b-badge',{attrs:{"pill":"","variant":value ? 'danger' : 'success'}},[_vm._v(_vm._s(value ? "محظور" : "فعال"))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }